import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';

import { setIsLoading } from '../../../../actions/general';

export const SET_SUBSCRIBER_DESIGNATIONS = 'setSubscriberDesignations';

export const API_SUBSCRIBER_DESIGNATION_ELEMENTS = 'user/designation-elements';

export const setSubscriberDesignationElements = (designationElements) => {
     return {
          type: SET_SUBSCRIBER_DESIGNATIONS,
          payload: designationElements,
     };
};

export const fetchSubscriberDesignationElementsRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SUBSCRIBER_DESIGNATION_ELEMENTS, 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setSubscriberDesignationElements(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
